import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteUserCreditCardAction } from 'src/redux/actions/paymentInfoAction';

const DeleteUserCreditCardDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteUserCreditCard]) {
        return state.dialog[DIALOGS.deleteUserCreditCard];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteUserCreditCard }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteUserCreditCard }));
    dispatch(deleteUserCreditCardAction(payload));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-credit-card"
      open={opened}>
      <DialogTitle id="deleting-credit-card">{t(lang, 'menus.deleting_creditcard')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_creditcard_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserCreditCardDialog;
